export default {
  "wt-tag": "_wt-tag_jvtmnt_1",
  "wt-tag_size_xs": "_wt-tag_size_xs_jvtmnt_9",
  "wt-tag_size_s": "_wt-tag_size_s_jvtmnt_22",
  "wt-tag_size_m": "_wt-tag_size_m_jvtmnt_35",
  "wt-tag_clickable": "_wt-tag_clickable_jvtmnt_47",
  "wt-tag_removable": "_wt-tag_removable_jvtmnt_51",
  "wt-tag_disabled": "_wt-tag_disabled_jvtmnt_56",
  "wt-tag_theme_light": "_wt-tag_theme_light_jvtmnt_60",
  "wt-tag_theme_dark": "_wt-tag_theme_dark_jvtmnt_86",
  "wt-tag__content": "_wt-tag__content_jvtmnt_128",
  "wt-tag__close": "_wt-tag__close_jvtmnt_136"
};